<template>
  <v-container class="pa-0" grid-list-md>
    <v-row>
      <v-col :cols="12" :md="6">
        <v-autocomplete
          :items="salutationItems"
          v-model="form.sex"
          :label="$t('texts.salutation')"
          item-text="text"
          item-value="value"
          required
          :error-messages="errors.collect('userProfile.salutation')"
          v-validate="'required'"
          data-vv-name="userProfile.salutation"
          :data-vv-as="$t('texts.salutation')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12" :md="6">
        <v-text-field
          name="employeeFirstName"
          :label="$t('texts.firstName')"
          value=""
          v-model="form.first_name"
          required
          :error-messages="errors.collect('userProfile.firstName')"
          v-validate="'required'"
          data-vv-name="userProfile.firstName"
          :data-vv-as="$t('texts.firstName')"
        />
      </v-col>
      <v-col :cols="12" :md="6">
        <v-text-field
          name="employeeLastName"
          :label="$t('texts.lastName')"
          v-model="form.last_name"
          required
          :error-messages="errors.collect('userProfile.lastName')"
          v-validate="'required'"
          data-vv-name="userProfile.lastName"
          :data-vv-as="$t('texts.lastName')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12">
        <v-menu
          ref="dateOfBirthDate"
          :close-on-content-click="false"
          v-model="birthdayPicker"
          transition="scale-transition"
          offset-y
          min-width="290px"
          :return-value.sync="form.date_of_birth"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-on="on"
              ref="startDateToValidate"
              :label="$t('texts.birthday')"
              :value="form.date_of_birth | formatDateMedium"
              readonly
              required
              :error-messages="errors.collect('userProfile.birthday')"
            />
          </template>
          <v-date-picker
            v-model="form.date_of_birth"
            @input="$refs.dateOfBirthDate.save(form.date_of_birth)"
            header-color="primary"
            color="primary"
            locale="de-ch"
            :first-day-of-week="1"
            ref="dateOfBirthPicker"
            :max="birthdayMax"
            :min="birthdayMin"

          />
        </v-menu>
        <input
          hidden
          v-model="form.date_of_birth"
          v-validate="'required|date_format:yyyy-MM-dd'"
          data-vv-name="userProfile.birthday"
          :data-vv-as="$t('texts.birthday')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12" :md="6">
        <v-autocomplete
          :items="countries"
          v-model="form.nationality"
          :label="$t('texts.nationality')"
          item-value="iso"
          item-text="name"
          required
          :error-messages="errors.collect('userProfile.nationality')"
          v-validate="'required'"
          data-vv-name="userProfile.nationality"
          :data-vv-as="$t('texts.nationality')"
        />
      </v-col>
      <v-col :cols="12" :md="6" v-if="form.nationality !== 'CH'">
        <v-autocomplete
          :items="residencePermitItems"
          v-model="form.residence_permit"
          :label="$t('texts.residencePermit.label')"
          item-value="category"
          item-text="name"
          cache-items
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12" :md="8">
        <v-text-field
          name="employeeStreet"
          :label="$t('texts.street')"
          v-model="form.street"
          required
          :error-messages="errors.collect('userProfile.street')"
          v-validate="'required'"
          data-vv-name="userProfile.street"
          :data-vv-as="$t('texts.street')"
        />
      </v-col>
      <v-col :cols="12" :md="4">
        <v-text-field
          name="employeeStreetNumber"
          :label="$t('texts.streetNumber')"
          v-model="form.street_number"
          required
          :error-messages="errors.collect('userProfile.streetNumber')"
          v-validate="'required'"
          data-vv-name="userProfile.streetNumber"
          :data-vv-as="$t('texts.streetNumber')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12" :md="4">
        <v-text-field
          v-model="form.zip"
          name="employeeZip"
          :label="$t('texts.zip')"
          required
          :error-messages="errors.collect('userProfile.zip')"
          v-validate="'required|min:4|max:5'"
          data-vv-name="userProfile.zip"
          :data-vv-as="$t('texts.zip')"
        />
      </v-col>
      <v-col :cols="12" :md="8">
        <v-text-field
          name="employeePlace"
          :label="$t('texts.place')"
          v-model="form.place"
          required
          :error-messages="errors.collect('userProfile.place')"
          v-validate="'required'"
          data-vv-name="userProfile.place"
          :data-vv-as="$t('texts.place')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12">
        <v-autocomplete
          :items="countries"
          v-model="form.country"
          :label="$t('texts.country')"
          item-value="iso"
          item-text="name"
          required
          :error-messages="errors.collect('userProfile.country')"
          v-validate="'required'"
          data-vv-name="userProfile.country"
          :data-vv-as="$t('texts.country')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12">
        <v-text-field
          name="employeePhone"
          :label="$t('texts.phone')"
          v-model="form.phone"
          required
          :error-messages="errors.collect('userProfile.phone')"
          v-validate="'required'"
          data-vv-name="userProfile.phone"
          :data-vv-as="$t('texts.phone')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12">
        <v-text-field
          name="employeeEmail"
          :label="$t('texts.email')"
          v-model="form.email"
          required
          :error-messages="errors.collect('userProfile.email')"
          v-validate="'required|email'"
          data-vv-name="userProfile.email"
          :data-vv-as="$t('texts.email')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint no-unused-expressions: "off" */
/* eslint no-return-assign: "off" */
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';

const { mapState: mapGeneralState } = createNamespacedHelpers('general');

export default {
  inject: ['$validator'],
  props: {
    form: {
      type: Object,
    },
  },
  data() {
    return {
      birthdayPicker: false,
    };
  },
  watch: {
    birthdayPicker(value) {
      value && this.$nextTick(() => this.$refs.dateOfBirthPicker.activePicker = 'YEAR');
    },
  },
  computed: {
    ...mapGeneralState([
      'countries',
    ]),
    salutationItems() {
      const items = [
        { value: 1, text: this.$i18n.t('texts.salutationMr') },
        { value: 2, text: this.$i18n.t('texts.salutationMrs') },
      ];
      return items;
    },
    residencePermitItems() {
      const items = [
        { category: '', name: this.$i18n.t('texts.neither') },
        { category: 'L', name: this.$i18n.t('texts.residencePermit.L') },
        { category: 'B', name: this.$i18n.t('texts.residencePermit.B') },
        { category: 'C', name: this.$i18n.t('texts.residencePermit.C') },
        { category: 'G', name: this.$i18n.t('texts.residencePermit.G') },
      ];
      return items;
    },
    birthdayMin() {
      return moment().subtract(80, 'years').format('YYYY-MM-DD');
    },
    birthdayMax() {
      return moment().subtract(15, 'years').format('YYYY-MM-DD');
    },
  },
};
</script>
